@if (loading()) {
  <p class="email-trail__loading" aria-live="polite">Loading…</p>
} @else if (error()) {
  <p class="email-trail__empty" role="alert">Couldn't load emails. <button type="button" class="email-trail__retry" (click)="retry.emit()">Try again</button></p>
} @else if (emails().length === 0) {
  <p class="email-trail__empty">No emails yet.</p>
} @else {
  <ol class="timeline email-trail__timeline">
    @for (email of emails(); track email.id) {
      <li class="timeline__item">
        <div class="email-trail__heading">
          <span class="email-trail__category">{{ email.category_display }}</span>
          <app-status-chip [status]="email.status" />
        </div>

        <span class="timeline__meta">
          {{ email.created_at | date: 'medium' }} · {{ email.to_email }}
        </span>

        @if (email.status === 'FAILED' && email.error) {
          <p class="email-trail__error">{{ email.error }}</p>
        }

        <p class="email-trail__engagement" [attr.data-engaged]="email.click_count > 0">
          @if (email.click_count > 0) {
            Link clicked {{ email.click_count }}× · last
            {{ email.last_clicked_at | date: 'medium' }}
          } @else {
            No link clicks yet.
          }
        </p>

        <div class="email-trail__disclosure">
          <button
            type="button"
            class="email-trail__toggle"
            [attr.aria-expanded]="isOpen(email.id)"
            [attr.aria-controls]="'email-body-' + email.id"
            (click)="toggleBody(email.id)"
          >
            {{ isOpen(email.id) ? 'Hide email content' : 'View email content' }}
          </button>
          @if (isOpen(email.id)) {
            <div
              class="email-trail__body"
              [id]="'email-body-' + email.id"
              role="region"
              aria-label="Email content"
            >
              @if (email.html_body) {
                <!-- Angular's [innerHTML] binding sanitizes by default — scripts and
                     dangerous attributes are stripped by DomSanitizer before insertion. -->
                <div class="email-trail__html" [innerHTML]="email.html_body"></div>
              } @else {
                <p class="email-trail__purged">Content no longer retained.</p>
              }
            </div>
          }
        </div>
      </li>
    }
  </ol>
}
